import { Component, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ConfigService } from '../../../services/config.service';
import { GeoServices } from '../../../services/geo.service';
import { Http } from '@angular/http';
import { BSModalContext } from 'angular2-modal/plugins/bootstrap/src/bootstrap';
import { ModalComponent, DialogRef } from 'angular2-modal';
import { FormContainerComponent } from './form-container.component';
import { ComponentsManagerService } from 'nm-socle-application/app/shared/services/component-manager.service';

export class ModalFormComponentContext extends BSModalContext { }

@Component({
    selector: 'modal-form',
    templateUrl: './form-container.component.html',
    styleUrls: ['./form-container.component.scss']
})

export class ModalFormComponent extends FormContainerComponent implements ModalComponent<ModalFormComponentContext> {
    public context: ModalFormComponentContext;

    constructor(
        public dialog: DialogRef<ModalFormComponentContext>,
        protected _configService: ConfigService,
        protected _geoServices: GeoServices,
        protected _http: Http,
        protected elRef: ElementRef,
        protected _componentsManagerService: ComponentsManagerService,
        protected _cd: ChangeDetectorRef,

    ) {
        super(_configService, _geoServices, _http, elRef, _componentsManagerService, _cd)

        this.context = dialog.context;
        this.componentName = this.context.component;
    }

    public ngOnInit() {
        if(this.context.component != undefined) {
            this.title = this.context['title'];
            this.icon = this.context['icon'];
            this.image = this.context['image'];

            this.componentName = this.context.component;

            super.ngOnInit();

            // if(this._compoRef != undefined && this._compoRef.instance['closeEvent'] != undefined) {
            //     this._subs.push(this._compoRef.instance['closeEvent'].subscribe(evt => {
            //         this.dialog.close()
            //     }));
            // }


        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/components/form-container/modal-form.component.ts